export default "__VITE_ASSET__BrMYdWFy__"